import { initAnimStack } from "./animStack";
import "./navMenu";
import Headroom from "headroom.js";

// window.addEventListener("anim-stack:ready", (event) => {
//   const { lenis, gsap, ScrollTrigger } = event.detail;
//   console.log("animation stack ready", lenis, gsap, ScrollTrigger);
// });

initAnimStack();
document.body.classList.add("header-at-top");

document
  .querySelector(".drawer-toggle")
  .addEventListener("click", function () {});
const headerElement = document.querySelector(".header");

// Headroom
const disableHeaderOverlayTopMeta = document.querySelector(
  'meta[name="disable-top-overlay"]',
);

if (
  disableHeaderOverlayTopMeta &&
  disableHeaderOverlayTopMeta.getAttribute("content") === "true"
) {
  // headerElement.classList.add("header--top-no-overlay");
  // headerElement.classList.add("header--black");
  document.body.classList.add("header-no-overlay");
  // Calculate header height and add it as padding to the body
  const headerHeight = headerElement.offsetHeight;
  document.body.style.paddingTop = `${headerHeight}px`;
}

const headroom = new Headroom(headerElement, {
  tolerance: 0,
  offset: 10,
  classes: {
    initial: "header",
    pinned: "header--fixed",
    unpinned: "header--fixed",
    top: "header--top header--white",
    notTop: "header--scrolled header--black",
  },
  onTop: function () {
    document.body.classList.add("header-at-top");
  },
  onNotTop: function () {
    document.body.classList.remove("header-at-top");
  },
});

headroom.init();
